import React from 'react';
import ReactCountryFlag from "react-country-flag";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LanguageIcon from '@material-ui/icons/Language';

import {Link} from "gatsby";

export default function LanguageSwitcher({defaultLanguage}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} style={{margin: 0, padding: 0}}>
                <LanguageIcon style={{marginRight: '0.2em'}}/> {defaultLanguage == "en" ? "EN - Language" : "DE - Sprache"}
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <Link to="/en/relaqua-relaxation-programm/"><MenuItem onClick={handleClose}><ReactCountryFlag style={{marginRight: '0.2em'}} countryCode="GB" /> English</MenuItem></Link>
                <Link to="/relaqua-entspannung/"><MenuItem onClick={handleClose}><ReactCountryFlag style={{marginRight: '0.2em'}} countryCode="DE" /> Deutsch</MenuItem></Link>
            </Menu>
        </div>
    );
}